import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, isNil } from 'lodash'
import LabeledTextField from '../common/LabeledTextField'
import SelectField from '../common/SelectField'
import CheckboxFieldSet from '../common/CheckboxFieldSet'
import SubmitButton from '../common/SubmitButton'

class InternalUserForm extends Component {
  static propTypes = {
    defaultRoles: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object,
    initialValues: PropTypes.object.isRequired,
    requestInProgress: PropTypes.bool.isRequired,
    submitLabel: PropTypes.string
  }

  static defaultProps = {
    submitLabel: 'Create Internal User'
  }

  constructor(props) {
    super(props)

    const initialValues = cloneDeep(props.initialValues)

    this.state = {
      values: initialValues
    }
  }

  get roleNames() {
    return this.props.defaultRoles.map((role) => { return role.name })
  }

  handleBlur = (field) => {}

  handleChange = (field, value) => {
    this.setState((prevState) => {
      const newState = prevState.values

      if (isNil(value) || value === '') {
        newState[field] = null
      } else {
        newState[field] = value
      }

      return { values: newState }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.props.handleSubmit(this.state.values)
  }

  render() {
    const { errors } = this.props

    return (
      <form className="pure-form pure-form-stacked" onSubmit={this.handleSubmit}>
        <fieldset>
          <LabeledTextField
            key="username"
            name="username"
            label="Username"
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            errorMessage={errors.username}
            value={this.state.values.username}
          />

          <LabeledTextField
            key="email"
            name="email"
            label="Email"
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            errorMessage={errors.email}
            value={this.state.values.email}
          />
        </fieldset>

        <fieldset>
          <SelectField
            key="user_type"
            name="user_type"
            label="User type"
            options={[{ value: 'internal', text: 'Internal' }, { value: 'system', text: 'System' }]}
            handleChange={this.handleChange}
            errorMessage={errors.user_type}
            value={this.state.values.user_type}
            disabled={false}
          />
        </fieldset>

        <fieldset>
          <CheckboxFieldSet
            name="roles"
            label="Roles"
            options={this.roleNames}
            handleBlur={this.handleBlur}
            handleChange={this.handleChange}
            value={this.state.values.roles}
          />
        </fieldset>

        <fieldset>
          <SubmitButton
            title={this.props.submitLabel}
            text={this.props.submitLabel}
            loading={this.props.requestInProgress}
          />
        </fieldset>
      </form>
    )
  }
}

export default InternalUserForm
